import ScrollTopButton from './scroll-top-button';

export default ScrollTopButton;
